import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const Structure3DIcon = (t0)=>{
    const $ = c(7);
    const { width, height, color } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsx("g", {
            filter: "url(#filter0_i_3982_59682)",
            children: /*#__PURE__*/ jsx("path", {
                d: "M25.908 4.80005C28.5825 4.80005 29.5524 5.07853 30.5301 5.60145C31.5079 6.12437 32.2753 6.89173 32.7982 7.86951C33.2863 8.7821 33.5614 9.6878 33.5959 11.979L33.5996 13.2H36.872C39.3497 13.2 40.3524 13.4785 41.3302 14.0014C42.3079 14.5244 43.0753 15.2917 43.5982 16.2695C44.1211 17.2473 44.3996 18.25 44.3996 20.7277V25.0467C44.3996 27.1864 44.1768 27.9623 43.7585 28.7445C43.3508 29.5068 42.7574 30.1092 42.0035 30.5266L41.9996 34.2001C41.9996 38.3593 38.7441 41.7582 34.6422 41.9877L34.1996 42H13.7996C9.64033 42 6.24142 38.7446 6.01196 34.6427L5.99961 34.2001V30.5233L5.67822 30.3336C5.07376 29.9313 4.58934 29.3963 4.24073 28.7445C3.85457 28.0224 3.63504 27.3058 3.60355 25.5169L3.59961 20.7277C3.59961 18.25 3.87809 17.2473 4.40101 16.2695C4.92393 15.2917 5.69129 14.5244 6.66907 14.0014C7.57701 13.5159 8.50641 13.2411 10.6183 13.2043L14.3996 13.2024V12.4917C14.3996 9.81715 14.6781 8.84729 15.201 7.86951C15.7239 6.89173 16.4913 6.12437 17.4691 5.60145C18.3817 5.11339 19.2874 4.83827 21.5786 4.80375L25.908 4.80005ZM38.405 31.1996L9.59961 31.1976V34.2001C9.59961 36.4037 11.2967 38.2109 13.4551 38.3861L13.7996 38.4001H34.1996C36.4032 38.4001 38.2105 36.703 38.3857 34.5445L38.3996 34.2001L38.405 31.1996ZM37.2798 16.8022H10.7194L9.97891 16.8233C9.12096 16.8671 8.74108 16.9758 8.36683 17.176C8.01642 17.3634 7.76294 17.6169 7.57554 17.9673C7.32534 18.4351 7.21795 18.9117 7.20179 20.3198L7.20106 25.4038L7.21328 25.9728C7.2321 26.455 7.27151 26.6968 7.33863 26.8785L7.41526 27.0467C7.49807 27.2016 7.59808 27.3016 7.75294 27.3844L7.92118 27.461C8.19363 27.5617 8.60152 27.6 9.75293 27.6H38.2463C39.3977 27.6 39.8056 27.5617 40.078 27.461L40.2463 27.3844C40.4011 27.3016 40.5011 27.2016 40.584 27.0467L40.6606 26.8785C40.7613 26.606 40.7996 26.1981 40.7996 25.0467V20.7277C40.7996 18.9984 40.6966 18.4776 40.4237 17.9673C40.2363 17.6169 39.9828 17.3634 39.6324 17.176C39.1646 16.9258 38.688 16.8184 37.2798 16.8022ZM26.3213 8.40184H21.6779L20.9161 8.41946C20.1416 8.45166 19.7391 8.52628 19.4106 8.66041L19.1668 8.77597C18.8164 8.96338 18.5629 9.21686 18.3755 9.56727L18.26 9.81107C18.0875 10.2334 18.0134 10.7781 18.0014 12.0783L17.9996 13.2H29.9996L29.9978 12.0783L29.9802 11.3165C29.948 10.5421 29.8734 10.1396 29.7393 9.81107L29.6237 9.56727C29.4363 9.21686 29.1828 8.96338 28.8324 8.77597L28.5886 8.66041C28.1662 8.48796 27.6216 8.41388 26.3213 8.40184Z",
                fill: color
            })
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx("defs", {
            children: /*#__PURE__*/ jsxs("filter", {
                id: "filter0_i_3982_59682",
                x: "2.59961",
                y: "4.80005",
                width: "41.8008",
                height: "38.2",
                filterUnits: "userSpaceOnUse",
                colorInterpolationFilters: "sRGB",
                children: [
                    /*#__PURE__*/ jsx("feFlood", {
                        floodOpacity: "0",
                        result: "BackgroundImageFix"
                    }),
                    /*#__PURE__*/ jsx("feBlend", {
                        mode: "normal",
                        in: "SourceGraphic",
                        in2: "BackgroundImageFix",
                        result: "shape"
                    }),
                    /*#__PURE__*/ jsx("feColorMatrix", {
                        in: "SourceAlpha",
                        type: "matrix",
                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                        result: "hardAlpha"
                    }),
                    /*#__PURE__*/ jsx("feOffset", {
                        dx: "-1",
                        dy: "1"
                    }),
                    /*#__PURE__*/ jsx("feGaussianBlur", {
                        stdDeviation: "0.5"
                    }),
                    /*#__PURE__*/ jsx("feComposite", {
                        in2: "hardAlpha",
                        operator: "arithmetic",
                        k2: "-1",
                        k3: "1"
                    }),
                    /*#__PURE__*/ jsx("feColorMatrix", {
                        type: "matrix",
                        values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
                    }),
                    /*#__PURE__*/ jsx("feBlend", {
                        mode: "normal",
                        in2: "shape",
                        result: "effect1_innerShadow_3982_59682"
                    })
                ]
            })
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== height || $[4] !== t1 || $[5] !== width) {
        t3 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2
            ]
        });
        $[3] = height;
        $[4] = t1;
        $[5] = width;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
export { Structure3DIcon };
